module.exports = __webpack_public_path__ + "img/tiktok-icon.523538f4.svg";